<template>
    <BaseModal @close="$emit('close')">
        <template #header>
            <img class="dcc-expired__icon" :src="icon" alt="" tabindex="-1" />
        </template>

        <div>
            <h2 class="dcc-expired__title">
                {{ $ml.get('dccExpiredTitle') }}
            </h2>
            <span class="dcc-expired__description">{{ description }}</span>
        </div>

        <template #footer>
            <button
                class="base-modal__btn base-modal__btn--primary base-modal__btn--full-width"
                @click="$emit('new-quote')"
            >
                {{ $ml.get('dccNewQuote') }}
            </button>
        </template>
    </BaseModal>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseModal from '@/components/template/BaseModal.vue';
import ErrorIcon from '@/assets/img/icons/error-v2.svg';
import DccCurrencies from '@/models/DccCurrencies';

export default {
    name: 'DccExpiredModal',

    components: { BaseModal },

    data() {
        return { icon: ErrorIcon };
    },

    computed: {
        ...mapGetters({
            expiredNotice: 'dcc/getExpiredNotice'
        }),

        description: (self) => {
            const notice = self.expiredNotice || {};
            const currency = DccCurrencies[notice.currencyCode] || {};
            const currencyName = currency.nameKey
                ? self.$ml.get(currency.nameKey)
                : notice.currencyCode;

            return self.$ml
                .with('currencyName', currencyName)
                .get('dccExpiredText');
        },
    },
};
</script>

<style scoped lang="scss">
.dcc-expired {
    &__icon {
        width: 56px;
        height: 56px;
    }

    &__title {
        font-size: 20px;
        font-weight: 700;
        color: #2F363E;
    }

    &__description {
        font-size: 16px;
        color: #5C6A7B;
    }
}
</style>
